// @flow
import * as React from "react";
import { Flex, Box, Heading, Subhead, Text } from "rebass";
import styled from "styled-components";
import omit from "lodash.omit";

import { metaDataProps } from "../pages/index";
import Button from "../components/ui/Button";
import Circle from "../components/ui/Circle";

type Props = {
  siteMetadata: metaDataProps
};

const propsToOmit = ["siteMetadata"];

const Stats = (props: Props) => (
  <StyledBox {...omit(props, propsToOmit)}>
    <div className="container">
      <Heading
        center
        mb={[3]}
        f={[3, 3, 4, 5]}
        px={[2]}
        color="support2"
        className="font-light"
      >
        Grow your business with Facebook Messenger&hellip;
      </Heading>

      <StyledSubhead
        is="p"
        mb={[4, 4, 5]}
        f={["14px", "15px", "15px"]}
        center
        color="support1"
      >
        Pipeline allows you to harness the power of Facebook Messenger and tap
        into over 1.3 billion active users.
      </StyledSubhead>

      <Flex mb={[4, 4, 5]} wrap>
        <Box w={[1, 1, 1 / 3]} mb={[4, 4, 0]} className="relative">
          <Stat center f={[5, 5, 6, 7]} color="support3" mb={[2]}>
            2 Billion
          </Stat>
          <Text
            center
            f={["12px", 2, 3]}
            color="support2"
            className="font-light"
          >
            Messages Sent/Month
          </Text>

          <CirclePointer>
            <CircleInner1 r={14.5} />
            <CircleInner2 r={20.5} />
            <CircleInner3 r={38} />
          </CirclePointer>
        </Box>
        <Box w={[1, 1, 1 / 3]} mb={[4, 4, 0]} className="relative">
          <Stat center f={[5, 5, 6, 7]} color="support3" mb={[2]}>
            1.3 Billion
          </Stat>
          <Text
            center
            f={["12px", 2, 3]}
            color="support2"
            className="font-light"
          >
            Active Messenger Users
          </Text>

          <SubscriberCircle1 r={8.5} />
          <SubscriberCircle2 r={18.5} />
          <SubscriberCircle3 r={13.5} />
        </Box>
        <Box w={[1, 1, 1 / 3]} mb={[4, 4, 0]} className="relative">
          <Stat center f={[5, 5, 6, 7]} color="support3" mb={[2]}>
            Over 80%
          </Stat>
          <Text
            center
            f={["12px", 2, 3]}
            color="support2"
            className="font-light"
          >
            Open Rates
          </Text>

          <CirclePointer2>
            <CircleInner1 r={14.5} />
            <CircleInner2 r={20.5} />
            <CircleInner3 r={38} />
          </CirclePointer2>
        </Box>
      </Flex>

      <Text center>
        <Button is="a" href={props.siteMetadata.appUrl}>
          GET STARTED FOR FREE
        </Button>
      </Text>
    </div>
  </StyledBox>
);

export default Stats;

// Styled Components
const Stat = styled(Text)`
  font-weight: 600;
  line-height: 1.2;
`;

const StyledSubhead = styled(Subhead)`
  font-weight: 300;
`;

const StyledBox = styled(Box)`
  opacity: 0.9;
  position: relative;
  z-index: 1;

  &:before {
    border: 1px solid rgba(151, 151, 151, 0.06);
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.08);
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    background: #f8fbfd;
    -ms-transform: skewY(-3deg);
    transform: skewY(-3deg);
    z-index: 0;
    top: 0;
    z-index: 1;
  }

  .container {
    position: relative;
    z-index: 2;
  }
`;

const CirclePointer = styled.div`
  left: 0;
  opacity: 0.9;
  position: absolute;
  top: -68px;
  transform: scale(0.4);

  @media (min-width: 48em) {
    transform: scale(0.6);
  }

  @media (min-width: 56em) {
    top: -68px;
    transform: scale(1);
  }
`;

const CirclePointer2 = CirclePointer.extend`
  bottom: -100px;
  left: auto;
  right: 20px;
  top: auto;
  transform: rotate(200deg) scale(0.5);

  @media (min-width: 48em) {
    transform: rotate(200deg) scale(0.6);
  }
`;

const CircleInner1 = styled(Circle)`
  left: -25px;
  position: absolute;
  top: 50px;
  }
`;

const CircleInner2 = styled(Circle)`
  left: 15px;
  position: absolute;
  top: 60px;
`;

const CircleInner3 = styled(Circle)`
  left: 65px;
  position: absolute;
  top: 70px;
`;

const SubscriberCircle1 = styled(Circle)`
  left: 20%;
  position: absolute;
  top: 0;
`;

const SubscriberCircle2 = styled(Circle)`
  position: absolute;
  right: 10%;
  top: -20px;
`;

const SubscriberCircle3 = styled(Circle)`
  bottom: -34px;
  position: absolute;
  right: 25%;
`;



// WEBPACK FOOTER //
// ./src/components/Stats.jsx